export let septemberUppercase = "zm9emc";
export default {septemberUppercase};